import React from "react";
import "./LoadingPage.css";
const LoadingPage = (props: { loading: boolean }): JSX.Element => {
  return <div className="loading" style={{ opacity: props.loading ? 1 : 0 }} />;
};
export { LoadingPage };
